import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_EXCEL_WARRANTY = {
  'list': [],
  'loading': false,
  'created': false,
};

const checkCreatedWarranties = (list) => {
  const created = list.find((warranty) => warranty?.code);

  if (created) {
    return true;
  }

  return false;
};

export const ExcelWarranty = (state, action) => {
  return createReducer(INITIAL_STATE_EXCEL_WARRANTY, {
    [ActionTypes.PROCESSING_WARRANTY_EXCEL_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.PROCESSED_WARRANTY_EXCEL_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'created': checkCreatedWarranties(action.response.data),
      'list': action.response.data,
    }),
    [ActionTypes.PROCESSED_WARRANTY_EXCEL_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'created': false,
      'list': [],
    }),
    [ActionTypes.ADDING_WARRANTY_EXCEL_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_WARRANTY_EXCEL_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'created': true,
      'list': action.response.data,
    }),
    [ActionTypes.ADDED_WARRANTY_EXCEL_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'created': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_WARRANTY_EXCEL_LIST]: (state, action) => ({
      ...INITIAL_STATE_EXCEL_WARRANTY,
    }),
  })(state, action);
};
